// Visual themes: what "dresses" the game - the rider on the progress bar
// and the stage animations, and the words around it (Salida/Meta/Parada,
// the animation phrases). Each season/event picks one (season.theme, edited
// in Panel.vue's season modal); the default is DEFAULT_THEME.
//
// Adding a theme:
//   1. A folder here with a Rider.vue - an inline SVG, flat white, with the
//      part that should take the team colour driven by the `color` prop.
//      Props: color, size (width in px at the 64-unit scale), moving (true
//      while it travels - spin wheels, bob, hop...). Its ground contact
//      point must be the bottom centre of the SVG: that's what sits on the
//      road.
//   2. An entry in THEMES below (texts + Bootstrap Icons for the markers).
//   3. Its id in shared/utils.js THEME_IDS, so the server accepts it.
import utils from '@/../../shared/utils'
import CyclingRider from './cycling/Rider.vue'
import CaminoRider from './camino/Rider.vue'
import AdventureRider from './adventure/Rider.vue'

const THEMES = {
    cycling: {
        id: 'cycling',
        label: 'Ciclismo',
        rider: CyclingRider,
        icons: { start: 'bi-flag', stop: 'bi-signpost-split-fill', finish: 'bi-flag-fill' },
        texts: {
            start: 'Salida',
            finish: 'Meta',
            stop: 'Parada',
            stop_reached: 'Parada alcanzada',
            intro_kicker: 'Vamos a empezar...',
            intro_title: 'La etapa de hoy',
            checkpoint_title: 'Veamos cómo ha ido',
        },
    },
    camino: {
        id: 'camino',
        label: 'Camino de Santiago',
        rider: CaminoRider,
        icons: { start: 'bi-geo-alt-fill', stop: 'bi-house-door-fill', finish: 'bi-star-fill' },
        texts: {
            start: 'Salida',
            finish: 'Llegada',
            stop: 'Albergue',
            stop_reached: 'Llegamos al albergue',
            intro_kicker: '¡Buen Camino!',
            intro_title: 'La etapa de hoy',
            checkpoint_title: 'Veamos cómo ha ido',
        },
    },
    adventure: {
        id: 'adventure',
        label: 'Aventura',
        rider: AdventureRider,
        icons: { start: 'bi-compass', stop: 'bi-fire', finish: 'bi-gem' },
        texts: {
            start: 'Campamento base',
            finish: 'El tesoro',
            stop: 'Campamento',
            stop_reached: 'Hacemos campamento',
            intro_kicker: 'Comienza la aventura...',
            intro_title: 'La expedición de hoy',
            checkpoint_title: 'Veamos cómo ha ido',
        },
    },
};

export function get_theme(id){
    return THEMES[id] || THEMES[utils.DEFAULT_THEME];
}

export function theme_list(){
    return utils.THEME_IDS.map((id) => THEMES[id]).filter(Boolean);
}

// Event mode: the theme of whichever season is live (same lookup as
// utils/jersey_model.js). Reads the reactive store, so computeds using it
// update when the season's theme is edited.
export function get_active_theme(){
    const game = (window.store && window.store.state.game) || {};
    const seasons = game.seasons || [];
    const season = seasons.find((s) => s.id == game.active_season_id) || seasons[0];
    return get_theme(season && season.theme);
}
